import React from 'react';
import styles from './form.module.scss';

interface Props extends React.PropsWithChildren<unknown> {
  label: string;
}

export default function FormGroup(props: Props) {
  return (
    <div className={styles.form_legend}>
      <div className={styles.legend}>{props.label}</div>
      <div>{props.children}</div>
    </div>
  );
}
